
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiFilter4 as ObiFilter4Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-filter-4.js';
 
 
 

 
 export const ObiFilter4 = createComponent({
   react: React,
   tagName: 'obi-filter-4',
   elementClass: ObiFilter4Element,
   events: {
     
   }
  });
 
 